<div class="container pb-4">
  <app-shared-action-bar [saveReady]="hasChange && !isSaving" [undoReady]="hasChange && !isSaving"
    [displayActionSectionBar]="showActionSectionBar" (saveRequest)="saveChanges()"
  (undoRequest)="undoChanges()"></app-shared-action-bar>




  <div class="px-4 md:px-8 mt-20">
    <h2 class="my-4 settings-header">Location {{ 'audit' | customerTerm:true }}</h2>
    @if (!showAudits) {
      <div class="mt-4">
        <p class="text-2xl font-bold">Select Location</p>
        @if (showLocation) {
          <div class="mx-5">
            @if (!topLevel) {
              <div (click)="resetLocations()" class="flex">
                <span
                class="text-center material-symbols-outlined text-green-700 self-center mr-1 ">undo</span><span class="hover:underline hover:cursor-pointer">Reset
              Locations</span>
            </div>
          }
          @if (locationsReady) {
            <div>
              @for (l of possibleLocations; track l) {
                <div class="flex w-full my-2">
                  <span
                    class="p-2 md:p-4 flex-grow standardTextSize border-spacing-1.5 border-b-grey-500 border-s-2 flex  align-middle hover:hover-for-select"
                    [ngClass]="{'selected': l.LocationID == selectedLocation.LocationID, 'hover:hover-for-select  ':l.HasPermission, 'bg-grey-100 hover:cursor-not-allowed':!l.HasPermission,' bg-grey-300':l.HasPermission&&l.LocationID!=selectedLocation.LocationID}"
                    (click)="selectLocation(l)">{{l.LocationName}}@if (!l.Active) {
                    <span
                    class="ml-2 text-grey-900 font-bold">(Inactive)</span>
                  }</span>
                  @if (locationHasChildren(l)) {
                    <div class=" bg-standardwhite "
                      (click)="buildLocationDDL(l.LocationID)">
                      <span
                        class="standardTextSize text-offblack hover:hover-for-select bg-grey-300 border-grey-900 border-spacing-2 border-s h-full px-4 flex items-center">Sub
                      Locations</span>
                    </div>
                  }
                </div>
              }
              @if (true) {
                <div class="mt-5">
                  <button class="btn-primary-full max-w-xl" (click)="confirmLocation()" [class.disabled]="!canStart"
                    [disabled]="!isLocationSelected">
                    @if (isLocationSelected) {
                      <span class="standardTextSize">Next ></span>
                    }
                    @if (!isLocationSelected) {
                      <span class="standardTextSize">Choose Location</span>
                    }
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <div class="">
      <h2>Loading...</h2>
    </div>
  }
  @if (showAudits && !isLoading) {
    <div class="">
      <div class="my-3">
        <h3>{{this.selectedLocation.LocationName}}</h3>
      </div>
      <div class="flex align-middle" (click)="resetPage()"><span
      class="text-center material-symbols-outlined text-green-700 self-center mr-1 ">undo</span><span class=" hover:underline hover:cursor-pointer">Change
    Location</span>
  </div>
  <table>
    <tbody>
      <tr class="border-b-offblack border-b-2 mb-2 py-1">
        <td class="font-bold">All</td>
        <td></td>
        <td class="flex justify-center py-2 pl-3 mr-2">
          <app-toggle-switch [(checked)]="allPermissions" (checkedChange)="updateAllPermissions()"></app-toggle-switch>
        </td>
        <td class="border-l-2 border-offblack p-2 ">Frequency</td>
      </tr>
      @for (a of audits; track a) {
        <tr>
          <td>{{a.AuditName}}</td>
          <td class="px-1">{{a.AuditType}}</td>
          <td class="flex justify-center py-2 pl-3 mr-2">
            <app-toggle-switch [(checked)]="a.AssignedToLocation" (checkedChange)="alterPermission()"></app-toggle-switch>
          </td>
          <td class="border-l-2 border-offblack p-2">
            <div class="flex hover:cursor-pointer hover:bg-green-50 hover:rounded-md p-2" (click)="editFrequency(a,true)">
              <span class="text-center material-symbols-outlined self-center mr-1 text-sm">edit</span>
              <p class="pl-1 text-sm">@if (a.FrequencyMultiplier > 1) {
                <span>{{a.FrequencyMultiplier}} x </span>
              }{{a.Frequency.Description}}</p>
            </div>
          </td>
        </tr>
        @if (a.ShowFrequencyUpdate) {
          <tr>
            <td colspan="4" class="border border-grey-500 p-2">
              <div class="flex justify-between">
                <h4 class="font-bold">Update Frequency</h4>
                <span class="text-center material-symbols-outlined self-center mr-1 text-sm hover:cursor-pointer hover:bg-green-50 hover:rounded-full w-5 h-5" (click)="editFrequency(a,false)">close</span>
              </div>
              <div class="grid grid-cols-2 mt-4 gap-2 items-center">
                <p>Number of times audit is required to be done in period:</p>
                <div class="pl-2">
                  <app-number-box-entry [(value)]="a.FrequencyMultiplier"></app-number-box-entry>
                </div>
                <p>Completion frequency:</p>
                <div class="pl-2">
                  <app-dropdown-entry [(value)]="a.Frequency" [options]="frequencies"></app-dropdown-entry>
                </div>
              </div>
            </td>
          </tr>
        }
      }
      <tr class="border-b-grey-500 border-b-[1px] mt-2 py-2"></tr>
    </tbody>
  </table>

</div>
}
</div>
</div>
